import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import AvatarEditor from './AvatarEditor';
import Input from '../../components/form/InputField';
import Loading from '../../components/Loading';
import NavBarNew from '../../components/toolbars/NavBarNew';

import { validateAndDispatch } from '../../helpers/form';
import { UserActions } from '../../actions/user';

import { currentUserSelector } from '../../reducers/users';

if (__CLIENT__) {
  require('../../styles/Dashboard.css');
}

function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

class UserTabs extends React.Component {
  static propTypes = {
    activeTab: PropTypes.string,
  };

  tabClasses = tabName => {
    const { activeTab } = this.props;
    return classNames({
      'nav-link': true,
      active: tabName === activeTab,
    });
  };

  render() {
    return (
      <ul className="nav nav-pills clearfix" style={{ paddingBottom: 10 }}>
        <li className="nav-item">
          <Link className={this.tabClasses('profile')} to="/user/profile">
            Profile
          </Link>
        </li>
        {/* <li className="nav-item">
          <Link className={this.tabClasses('settings')} to="/user/settings">Settings</Link>
        </li> */}
        <li className="nav-item">
          <Link className={this.tabClasses('email')} to="/user/email">
            Email
          </Link>
        </li>
        <li className="nav-item">
          <Link className={this.tabClasses('password')} to="/user/password">
            Password
          </Link>
        </li>
      </ul>
    );
  }
}

const userProfileFormSelector = state => {
  const selector = formValueSelector('userProfile');
  return selector(
    state,
    'displayName',
    'firstName',
    'lastName',
    'whatIDo',
    'bio',
  );
};

const buildUserObject = user => ({
  displayName: user.get('display_name'),
  firstName: user.get('first_name'),
  lastName: user.get('last_name'),
  companyName: user.get('company_name'),
  whatIDo: user.get('what_i_do'),
  bio: user.get('bio'),
});

const userPropSelector = (state, props) => props.user;

const UserProfileSelector = immutableCreatorSelector(
  [userProfileFormSelector, userPropSelector],
  (userProfileForm, userProp) => ({
    fields: userProfileForm,
    initialValues: buildUserObject(userProp),
  }),
);

@connect(UserProfileSelector)
@reduxForm({
  form: 'userProfile',
})
export class UserProfile extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    fields: PropTypes.object,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    user: PropTypes.instanceOf(Map),
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = (values, dispatch) => {
    const { user } = this.props;

    const validation = {
      // displayName: [{ rule: 'required', label: 'display name' }],
      firstName: [{ rule: 'required', label: 'first name' }],
      lastName: [{ rule: 'required', label: 'last name' }],
    };

    return validateAndDispatch(
      dispatch,
      UserActions.updateProfile(user.get('id'), values),
      validation,
      values,
    );
  };

  saveAvatar = () => {
    const { dispatch } = this.props;
    const dataURL = this.refs.avatar.getImage();
    const blob = dataURLtoBlob(dataURL);
    dispatch(UserActions.uploadAvatar(blob));
  };

  render() {
    const {
      fields: { bio },
      handleSubmit,
      submitting,
    } = this.props;

    // const { user } = this.props;
    // const username = user.get('username');
    // const avatarURL = user.get('hasAvatar') === true ?
    // `http://media.threadd.com/images/avatars/b/${username}.jpg` :
    // 'https://avatars.slack-edge.com/2015-07-27/8278866726_ceb59db09a5139be47b3_192.jpg';

    return (
      <div className="row">
        <div className="col-md-8">
          <form onSubmit={handleSubmit(this.submit)}>
            <fieldset className="form-group">
              <label htmlFor="firstName">First Name</label>
              <Field
                name="firstName"
                component={Input}
                type="text"
                className="form-control"
                placeholder="First Name"
              />
              {/* <FieldError field={firstName} /> */}
            </fieldset>
            <fieldset className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <Field
                name="lastName"
                component={Input}
                type="text"
                className="form-control"
                placeholder="Last Name"
              />
              {/* <FieldError field={lastName} /> */}
            </fieldset>
            <fieldset className="form-group">
              <label htmlFor="companyName">Company</label>
              <Field
                name="companyName"
                component={Input}
                type="text"
                className="form-control"
                placeholder="Company Name"
              />
              {/* <FieldError field={lastName} /> */}
            </fieldset>
            <fieldset className="form-group">
              <label htmlFor="whatIDo">What I Do</label>
              <Field
                name="whatIDo"
                component={Input}
                type="text"
                className="form-control"
                placeholder="What I Do"
              />
              {/* <FieldError field={whatIDo} /> */}
            </fieldset>
            <fieldset className="form-group">
              <label htmlFor="exampleTextarea">Bio</label>
              <Field
                name="bio"
                component="textarea"
                rows="3"
                className="form-control"
                placeholder="Describe yourself"
                value={bio || ''}
              />
              {/* <FieldError field={bio} /> */}
            </fieldset>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {submitting && <i className="fa fa-cog fa-spinner fa-spin" />}{' '}
              Save Changes
            </button>
          </form>
        </div>
        <div className="col-md-4">
          <AvatarEditor ref="avatar" />
        </div>
      </div>
    );
  }
}

export class UserSettings extends React.Component {
  render() {
    return (
      <div className="tab-content">
        <h3>Settings</h3>
      </div>
    );
  }
}

const userEmailFormSelector = state => {
  const selector = formValueSelector('userEmail');
  return selector(state, 'email');
};

const buildEmailObject = user => ({ email: user.get('email') });

const UserEmailSelector = immutableCreatorSelector(
  [userEmailFormSelector, currentUserSelector],
  (userEmailForm, user) => ({
    fields: {
      email: userEmailForm,
    },
    user,
    initialValues: buildEmailObject(user),
  }),
);

@connect(UserEmailSelector)
@reduxForm({
  form: 'userEmail',
})
export class UserEmail extends React.Component {
  static propTypes = {
    fields: PropTypes.object,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    user: PropTypes.instanceOf(Map),
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = (values, dispatch) => {
    const { user } = this.props;

    const validation = {
      email: [{ rule: 'required', label: 'email address' }],
    };

    return validateAndDispatch(
      dispatch,
      UserActions.changeEmail(user.get('id'), values),
      validation,
      values,
    );
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="row">
            <div className="col-md-8">
              <fieldset className="form-group">
                <label htmlFor="email">Email</label>
                <Field
                  name="email"
                  component={Input}
                  type="text"
                  parse={value => value.toLowerCase()}
                  className="form-control"
                  placeholder="Email"
                />
                {/* <FieldError field={email} /> */}
              </fieldset>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
              >
                {submitting && <i className="fa fa-cog fa-spinner fa-spin" />}{' '}
                Change Email
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const userPasswordFormSelector = state => {
  const selector = formValueSelector('userPassword');
  return selector(state, 'password', 'newPassword', 'newPassword2');
};

const UserPasswordSelector = immutableCreatorSelector(
  [userPasswordFormSelector, currentUserSelector],
  (userPasswordForm, user) => ({
    fields: userPasswordForm,
    user,
  }),
);

@connect(UserPasswordSelector)
@reduxForm({
  form: 'userPassword',
})
export class UserPassword extends React.Component {
  static propTypes = {
    fields: PropTypes.object,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    reset: PropTypes.func,
    user: PropTypes.instanceOf(Map),
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = (values, dispatch) => {
    const { user, reset } = this.props;

    const validation = {
      password: [{ rule: 'required', label: 'password' }],
      newPassword: [
        { rule: 'required', label: 'new password' },
        { rule: 'minLength:8', label: 'new password' },
        // { rule: 'matchesField:newPassword2',
        //   message: 'The password and password retry fields do not match' }
      ],
      newPassword2: [
        { rule: 'required', label: 'new password again' },
        {
          rule: 'matchesField:newPassword',
          message: 'Field does not match the new password',
        },
      ],
    };

    return validateAndDispatch(
      dispatch,
      UserActions.changePassword(user.get('id'), values),
      validation,
      values,
    ).then(() => reset());
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="row">
            <div className="col-md-8">
              <fieldset className="form-group">
                <label htmlFor="password">Current Password</label>
                <Field
                  name="password"
                  component={Input}
                  type="password"
                  className="form-control"
                  placeholder="Current Password"
                />
                {/* <FieldError field={password} /> */}
              </fieldset>
              <fieldset className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <Field
                  name="newPassword"
                  component={Input}
                  type="password"
                  className="form-control"
                  placeholder="New Password"
                />
                {/* <FieldError field={newPassword} /> */}
              </fieldset>
              <fieldset className="form-group">
                <label htmlFor="newPassword2">New Password Again</label>
                <Field
                  name="newPassword2"
                  component={Input}
                  type="password"
                  className="form-control"
                  placeholder="New Password"
                />
                {/* <FieldError field={newPassword2} /> */}
              </fieldset>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
              >
                {submitting && <i className="fa fa-cog fa-spinner fa-spin" />}{' '}
                Change Password
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

class Dashboard extends React.Component {
  static propTypes = {
    // dispatch: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    activeTab: PropTypes.string,
  };

  render() {
    const { children, activeTab } = this.props;
    return (
      <div>
        <NavBarNew />
        <div className="main-container" style={{ marginLeft: 50 }}>
          <div className="row">
            <div className="col-md-12">
              <h2>My Profile</h2>
              <UserTabs activeTab={activeTab} />
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const DashboardContainerSelector = immutableCreatorSelector(
  [currentUserSelector],
  currentUser => ({
    user: currentUser,
  }),
);

@connect(DashboardContainerSelector)
class DashboardContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    location: PropTypes.object,
  };

  render() {
    const {
      dispatch,
      children,
      location: { pathname },
      user,
    } = this.props;
    const activeTab = pathname.substr(pathname.lastIndexOf('/') + 1);

    if (!user.size) return <Loading loadingMessage="Loading profile..." />;

    return (
      <Dashboard dispatch={dispatch} activeTab={activeTab}>
        {React.Children.map(children, child =>
          React.cloneElement(child, { user }),
        )}
      </Dashboard>
    );
  }
}

export { DashboardContainer as UserDashboard };



// WEBPACK FOOTER //
// ./src/views/UserProfile/User.js